module.exports = __webpack_public_path__ + "assets/img/capitol-news.65c31e3a.svg";